import { register } from "../../../JavaScript/Utils";

export const Modal = () => {
  let lastFocusedElement;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const lang = getCurrentLanguage(); // Get current language

  // use as fallback, if no data attribute for button or aria label for close icon available
  const LANGUAGES = {
    de: {
      close: "Infobox schliessen"
    },
    en: {
      close: "Close infobox"
    }
  };

  function getCurrentLanguage() {
    return document.documentElement.lang || "de"; // Fallback german
  }

  // Check whether a modal exist and if not create one
  let modal = document.querySelector(".comp-modal");
  if (!modal) {
    modal = document.createElement("div");
    modal.classList.add("comp-modal");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.innerHTML = `
      <div class="comp-modal-content" tabindex="-1">
        <h2 class="comp-modal-title"></h2>
        <button class="js-modal-close comp-modal-content__close">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path d="M1.00492 0.622219C1.28136 0.33611 1.6228 0.225624 1.76756 0.375441L11.7361 10.6926C11.8808 10.8425 11.7741 11.1958 11.4976 11.482C11.2212 11.7681 10.8798 11.8786 10.735 11.7287L0.766484 1.41153C0.621731 1.26171 0.728483 0.908327 1.00492 0.622219Z" fill="currentColor" />
            <path d="M1.51114 11.3778C1.2347 11.0917 1.12795 10.7383 1.2727 10.5885L11.2412 0.271268C11.386 0.121451 11.7274 0.231937 12.0039 0.518045C12.2803 0.804154 12.387 1.15754 12.2423 1.30736L2.27378 11.6246C2.12902 11.7744 1.78758 11.6639 1.51114 11.3778Z" fill="currentColor"/>
        </svg>
        </button>
        <p class="comp-modal-text"></p>
        <button class="js-modal-close btn btn--primary comp-modal-close-button"></button>
      </div>
    `;
    document.body.appendChild(modal);
  }

  const modalContent = modal.querySelector(".comp-modal-content");
  const modalTitle = modal.querySelector(".comp-modal-title");
  const modalText = modal.querySelector(".comp-modal-text");
  const closeButtonText = modal.querySelector(".comp-modal-close-button");
  const closeModalIcon = modal.querySelector(".comp-modal-content__close");
  const closeModalButtons = modal.querySelectorAll(".js-modal-close");

  let firstFocusableElement, lastFocusableElement;

  // Open modal
  const openModal = (title, text, buttonText,ariaLabelCloseIcon) => {
    lastFocusedElement = document.activeElement;
    modalTitle.textContent = title;
    modalText.textContent = text;
    closeButtonText.textContent = buttonText;
    closeModalIcon.ariaLabel = ariaLabelCloseIcon;

    updateFocusableElements();

    document.body.classList.add("comp-modal-open");

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    modal.classList.add("is--active");
    setTimeout(()=> {
      modalContent.focus();
    },10)

    // Keydown-Event when modal is open
    document.addEventListener("keydown", handleKeyEvents);
  };

  // Close modal
  const closeModal = () => {
    modal.classList.remove("is--active");
    document.body.classList.remove("comp-modal-open");
    document.body.style.paddingRight = "";

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }

    document.removeEventListener("keydown", handleKeyEvents);
  };

  const updateFocusableElements = () => {
    const focusableElements = modalContent.querySelectorAll("button, a, input, textarea, select");
    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
  };

  const handleKeyEvents = (event) => {
    if (event.key === "Escape") {
      closeModal();
    } else if (event.key === "Tab") {
      trapFocus(event);
    }
  };

  // Focus trap
  const trapFocus = (event) => {
    if (!firstFocusableElement || !lastFocusableElement) return;

    if (event.shiftKey && document.activeElement === firstFocusableElement) {
      event.preventDefault();
      lastFocusableElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  };

  // Close box if user clicking outside of modal
  modal.addEventListener("click", (event) => {
    const targetElement = event.target as Node;
    if (!modalContent.contains(targetElement)) {
      closeModal();
    }
  });


  // Event-Handling for close button
  closeModalButtons.forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  // Event Delegation for all buttons with data-component="Modal"
  document.body.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-component='Modal']");

    if(trigger) {
      event.preventDefault();
    }
    else {
      return;
    }

    lastFocusedElement = trigger;

    const title = trigger.getAttribute("data-title") || "";
    const text = trigger.getAttribute("data-text") || "";
    const buttonText = trigger.getAttribute("data-button") || `${LANGUAGES[lang]?.close || LANGUAGES.de.close}`;
    const ariaLabelCloseIcon = trigger.getAttribute("data-aria-label-close") || `${LANGUAGES[lang]?.close || LANGUAGES.de.close}`;

    openModal(title, text, buttonText, ariaLabelCloseIcon);
  });
};

register("Modal", Modal);
